// Selector contracts for the guided-tour engine (WP4).
//
// Every value is a CSS selector string handed straight to document.querySelector
// inside TourProvider's anchor-resolution loop. Comma-separated selectors are a
// native querySelector feature: the FIRST element in DOCUMENT order matching ANY
// listed selector wins (not the first selector) — so a fallback that is an
// ANCESTOR of the primary target would always win and must never be listed
// alongside a more specific descendant. The fallbacks here are therefore only
// used for elements the parallel packages are still adding (SideNav data-tour
// links, TopBar help/about/copilot data-tour attributes): the not-yet-shipped
// [data-tour="…"] selector is listed first, with an already-shipping equivalent
// (or nothing, relying on missing-anchor grace) as the fallback.
//
// PREFER existing data-testid selectors. A bare class selector is used only where
// a page ships no stable testid on the container a step needs to highlight; those
// are called out in the WP4 report.

// Shown in the panel when an anchor cannot be resolved within the retry window.
export const DEFAULT_FALLBACK_BODY =
  "This control isn't available with your current role or data. The step still explains what it does.";

export const ANCHORS = Object.freeze({
  // ── Orientation (all steps render on /home; these highlight shell chrome) ──
  homeAttention: '[data-testid="home-attention-strip"]',
  // The nav rail container ships today; the parallel SideNav package adds a
  // per-link [data-tour="nav:/projects"]. Rail is the intended highlight either
  // way, and it is the ancestor so it wins — which is what this step wants.
  navRail: '[data-testid="app-shell-rail"]',
  // Parallel SideNav addition; grace covers its current absence.
  navViewToggle: '[data-testid="nav-view-toggle"]',
  topbarSearch: '[data-testid="app-topbar"] [role="search"]',
  // Parallel TopBar additions; grace + fallbackBody cover current absence.
  aboutThisPage: '[data-tour="about-this-page"]',
  // Copilot launcher ships today as prime-copilot-launcher; parallel TopBar adds
  // the data-tour alias to the same element, so either resolves the same node.
  copilotLauncher: '[data-tour="copilot-launcher"], [data-testid="prime-copilot-launcher"]',
  helpMenu: '[data-tour="help-menu"]',

  // ── J1 · Lifecycle ──
  factoryQueue: '[data-testid="owha-project-factory-page"]',
  factoryIntakeForm: '[data-testid="owha-project-factory-create-page"]',
  projectsList: '.projects-table-scroll',
  projectsGate: '.projects-list-table',
  actionCenter: '[data-testid="action-center-page"]',

  // ── J2 · Data to decision ──
  ingestionUpload: '.ingestion-upload-card',
  lineageGraph: '[data-testid="provenance-graph"], [data-testid="resource-flow-preview"]',
  loeBoard: '[data-testid="owha-loe-board"]',
  // Owned data-tour anchor on the executive attention/KPI zone; falls back to the
  // Director's Daily Brief "as of" chip so the daily-brief affordance is framed.
  execCommandCenter: '[data-tour="exec-command-center"], [data-testid="ddb-as-of"]',

  // ── J3 · First week ──
  accessStatus: '.access-page',
  loeFilterToolbar: '[data-testid="owha-loe-filter-toolbar"]',
  feedbackQueue: '.feedback-ops-panel',
  customFieldForm: '.admin-config-create-form',
  uatSatisfaction: '[data-testid="kpi-card-hero-satisfaction"]',
});
